import { V1_API_BASE_URL } from 'constants/urls'
import { fetchResource, postResource } from 'utils/fetchUtils'
import config from '../../../config'

export const getAll = () => fetchResource(`${V1_API_BASE_URL}/districts`)

export const getOne = districtId =>
  fetchResource(`${V1_API_BASE_URL}/districts/${districtId}`)

export const getAllFlyers = districtId =>
  fetchResource(`${V1_API_BASE_URL}/districts/${districtId}/flyers`)

export const getOneFlyer = (districtId, flyerId) =>
  fetchResource(`${V1_API_BASE_URL}/districts/${districtId}/flyers/${flyerId}`)

export const postOneFlyer = ({ body }) =>
  postResource(`${config.V2_API_HOST_NAME}/api/metrics/v2`, {
    body
  })



// WEBPACK FOOTER //
// ./src/shared/models/districts/index.js